import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexModule, GridModule } from '@angular/flex-layout';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UtilsModule } from '../../utils/utils.module';
import { TabsComponent } from './tabs.component';
import { ColorUtilsService } from '@nx-monorepo/obce/ng/services';

@NgModule({
  imports: [CommonModule, GridModule, FlexModule, FontAwesomeModule, MatMenuModule, RouterModule, MatIconModule, MatButtonModule, BrowserAnimationsModule, UtilsModule, MatInputModule],
  declarations: [TabsComponent],
  entryComponents: [TabsComponent],
  providers: [ColorUtilsService],
  exports: [TabsComponent]
})
export class TabsModule {}

